export default {"src":"/_next/static/media/magnifier.e27fb848.svg","height":20,"width":20};